import React from "react";
import styles from "./BlogInner.module.css";
import BlogSecRight from "./BlogSecRight/BlogSecRight";
import BlogSecLeft from "./BlogSecLeft/BlogSecLeft";
import Breadcrumbs from "../Common/Breadcrumbs";
export default function BlogInner({ postData, postSlug, recentBlogs = [], onShareClick }) {
  return (<>
    <Breadcrumbs />
    <section className="standard-padding blog-detail-page">
      <div className={styles.blogInnerGrid}>
        <BlogSecLeft postData={postData} postSlug={postSlug} />
        <BlogSecRight
          postData={postData}
          recentBlogs={recentBlogs}
          onShareClick={onShareClick}
        />
      </div>
    </section>
  </>);
}